import { useToast } from "@/components/ui/use-toast";
import { cn } from "@/lib/utils";
import { X } from "lucide-react";
import { useEffect } from "react";

export function Toaster() {
  const { toasts, dismiss } = useToast();

  // Auto-dismiss toasts after their duration
  useEffect(() => {
    toasts.forEach((toast) => {
      if (toast.id) {
        const timer = setTimeout(() => {
          dismiss(toast.id);
        }, 3000); // 3 seconds
        return () => clearTimeout(timer);
      }
    });
  }, [toasts, dismiss]);

  return (
    <div className="fixed bottom-0 right-0 z-100 flex max-h-screen w-full flex-col-reverse p-4 sm:flex-col md:max-w-[420px]">
      {toasts.map(
        ({
          id,
          title,
          description,
          variant,
          action,
          onOpenChange,
          ...props
        }) => (
          <div
            key={id}
            className={cn(
              "group pointer-events-auto relative flex w-full items-center justify-between space-x-4 overflow-hidden rounded-lg border-2 p-4 pr-10 shadow-lg transition-all mb-2 animate-in slide-in-from-bottom-full backdrop-blur-sm",
              variant === "destructive"
                ? "border-red-600 bg-red-50/30 dark:bg-red-950/30"
                : "border-green-600 bg-green-50/30 dark:bg-green-950/30"
            )}
            {...props}
          >
            <div className="grid gap-1 flex-1">
              {title && (
                <div
                  className={cn(
                    "text-sm font-bold",
                    variant === "destructive"
                      ? "text-red-700 dark:text-red-400"
                      : "text-green-700 dark:text-green-400"
                  )}
                >
                  {title}
                </div>
              )}
              {description && (
                <div
                  className={cn(
                    "text-sm font-medium",
                    variant === "destructive"
                      ? "text-red-900 dark:text-red-300"
                      : "text-green-900 dark:text-green-300"
                  )}
                >
                  {description}
                </div>
              )}
            </div>
            <button
              onClick={() => dismiss(id)}
              className={cn(
                "absolute right-2 top-2 rounded-md p-1 opacity-70 transition-opacity hover:opacity-100 focus:outline-none focus:ring-2",
                variant === "destructive"
                  ? "text-red-700 hover:bg-red-100 focus:ring-red-400 dark:text-red-400 dark:hover:bg-red-900"
                  : "text-green-700 hover:bg-green-100 focus:ring-green-400 dark:text-green-400 dark:hover:bg-green-900"
              )}
            >
              <X className="h-4 w-4" />
            </button>
          </div>
        )
      )}
    </div>
  );
}
